/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You weighed 0.5 g of a compound (MW 180.16) into 100 mL: concentration = 0.5 / (0.1 × 180.16) = 0.0278 M.`)
};

const es_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesaste 0.5 g de un compuesto (PM 180.16) en 100 mL: concentración = 0.5 / (0.1 × 180.16) = 0.0278 M.`)
};

const de_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben 0,5 g einer Verbindung (MW 180,16) in 100 mL eingewogen: Konzentration = 0,5 / (0,1 × 180,16) = 0,0278 M.`)
};

const nl_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt 0,5 g van een verbinding (MW 180,16) afgewogen in 100 mL: concentratie = 0,5 / (0,1 × 180,16) = 0,0278 M.`)
};

const fr_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez pesé 0,5 g d'un composé (MM 180,16) dans 100 mL : concentration = 0,5 / (0,1 × 180,16) = 0,0278 M.`)
};

const it_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai pesato 0,5 g di un composto (PM 180,16) in 100 mL: concentrazione = 0,5 / (0,1 × 180,16) = 0,0278 M.`)
};

const pt_br2_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pesou 0,5 g de um composto (MM 180,16) em 100 mL: concentração = 0,5 / (0,1 × 180,16) = 0,0278 M.`)
};

const pt_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesou 0,5 g de um composto (MM 180,16) em 100 mL: concentração = 0,5 / (0,1 × 180,16) = 0,0278 M.`)
};

const ja_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化合物0.5 g (分子量180.16) を100 mLに秤量: 濃度 = 0.5 / (0.1 × 180.16) = 0.0278 M。`)
};

const zh_massmol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你称取了 0.5 g 某化合物（分子量 180.16）溶于 100 mL：浓度 = 0.5 / (0.1 × 180.16) = 0.0278 M。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_ex3", locale)
	if (locale === "en") return en_massmol_ex3(inputs)
	if (locale === "es") return es_massmol_ex3(inputs)
	if (locale === "de") return de_massmol_ex3(inputs)
	if (locale === "nl") return nl_massmol_ex3(inputs)
	if (locale === "fr") return fr_massmol_ex3(inputs)
	if (locale === "it") return it_massmol_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_ex3(inputs)
	if (locale === "pt") return pt_massmol_ex3(inputs)
	if (locale === "ja") return ja_massmol_ex3(inputs)
	return zh_massmol_ex3(inputs)
};